module.exports = __webpack_public_path__ + "media/images/flags/bb-f1866cb581c9eed0ade4244519ed944c.svg";